const Campaign = () => import('@/modules/campaign');

export default [
  {
    path: '/franquia/destaques/:id/resumo/',
    component: Campaign,
    name: 'franchise-campaign-resume',
    meta: {
      navbarTitle: 'Resumo do destaque',
      drawerComponent: () => import('@/modules/campaign/_components/CampaignEditForm/index.vue'),
    },
  },
  {
    path: '/franquia/destaques/:id/edit/',
    component: Campaign,
    name: 'franchise-campaign-edit',
    meta: {
      navbarTitle: 'Resumo do destaque',
      drawerComponent: () => import('@/modules/campaign/_components/CampaignEditForm/index.vue'),
    },
  },
  {
    path: '/destaques/:id/resumo/',
    component: Campaign,
    name: 'campaign-resume',
    meta: {
      navbarTitle: 'Resumo do destaque',
      drawerComponent: () => import('@/modules/campaign/_components/CampaignEditForm/index.vue'),
    },
  },
  {
    path: '/destaques/:id/edit/',
    component: Campaign,
    name: 'campaign-edit',
    meta: {
      navbarTitle: 'Resumo do destaque',
      drawerComponent: () => import('@/modules/campaign/_components/CampaignEditForm/index.vue'),
    },
  },
];
